import { render, staticRenderFns } from "./addGoodsPurchaseReturn.vue?vue&type=template&id=4a6f3b94&scoped=true"
import script from "./addGoodsPurchaseReturn.vue?vue&type=script&lang=js"
export * from "./addGoodsPurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./addGoodsPurchaseReturn.vue?vue&type=style&index=0&id=4a6f3b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f3b94",
  null
  
)

export default component.exports